import { defineMessages } from 'react-intl';

export default defineMessages({
    class: {
        id: 'app.components.StudentClassList.class',
        defaultMessage: 'CLASS'
    },
    group: {
        id: 'app.components.StudentClassList.group',
        defaultMessage: 'GROUP'
    },
    course: {
        id: 'app.components.StudentClassList.course',
        defaultMessage: 'COURSE'
    },
    teacher: {
        id: 'app.components.StudentClassList.teacher',
        defaultMessage: 'TEACHER'
    },
    year: {
        id: 'app.components.StudentClassList.year',
        defaultMessage: 'YEAR'
    },
    unassignStudent: {
        id: 'app.components.StudentClassList.unassignStudents',
        defaultMessage: 'Unassign Student'
    },
    studentsUnassigned: {
        id: 'app.components.StudentClassList.studentsUnassigned',
        defaultMessage: 'Student have been unassigned'
    },
    selectedStudentWillBe: {
        id: 'app.components.StudentClassList.selectedStudentWillBe',
        defaultMessage: 'The selected student will be'
    },
    unassignedClassList: {
        id: 'app.components.StudentClassList.unassignedClassList',
        defaultMessage: 'unassigned'
    },
    mayLoseAccessToProducts: {
        id: 'app.components.StudentClassList.mayLoseAccessToProducts',
        defaultMessage: 'and may lose access to the current product.'
    }
});



// WEBPACK FOOTER //
// ./app/components/student-class-list/messages.js